import 'lenis/dist/lenis.css'
import '../css/main.css'
import { initAmenities } from './modules/amenities'
import { initAnchorLinks } from './modules/anchorLinks'
import { initEnquiryForm } from './modules/enquiryForm'
import { initHeader, initMobileMenu } from './modules/header'
import { initIntro } from './modules/introSequence'
import { initLegalModals } from './modules/legalModals'
import { initReveals } from './modules/reveals'
import { initVrTour } from './modules/vrTour'
import { initSmoothScroll } from './utils/smoothScroll'

/**
 * Entry point. Every page feature lives in its own module under `modules/`
 * (with the reusable pieces they share in `utils/`); this file only decides
 * what runs and in what order.
 *
 * Each init bails when its markup is absent, so one bundle serves every
 * template — the landing page, the VR variant and the thank-you page.
 */

/**
 * Smooth scrolling (Lenis) wired into GSAP ScrollTrigger. Null when the visitor
 * prefers reduced motion, in which case everything handed it falls back to the
 * browser's native scrolling.
 */
const lenis = initSmoothScroll()

/** Splash → hero landing sequence (pauses scroll while it plays). */
initIntro(lenis)

initAnchorLinks(lenis)
initHeader()
initMobileMenu()
initAmenities()
initEnquiryForm()
initVrTour(lenis)
initReveals()
initLegalModals()
